export default "__VITE_ASSET__B$p4vTf0__"